export const controleTarefasEmum = {
  RECEPTACULOS: 1,
  IMUNO: 2,
  LAMINAS_CITOLOGIA: 3,
  LAMINAS_HISTOLOGIA: 4
};



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/controle-tarefas.utils.js